import { parseAsString, parseAsStringLiteral, useQueryState, useQueryStates } from 'nuqs';
import { RequirePermission } from '@/app/require-permission';
import { PageHeader } from '@/components/shared/page-header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useSession } from '@/lib/session';
import { RulesTab } from './rules-tab';
import { StatementTab } from './statement-tab';

const TABS = ['extrato', 'regras'] as const;

function CommissionsContent() {
  const { can } = useSession();
  const [tab, setTab] = useQueryState('aba', parseAsStringLiteral(TABS).withDefault('extrato').withOptions({ history: 'replace' }));
  const [, setShared] = useQueryStates({ page: parseAsString, q: parseAsString }, { history: 'replace' });
  const manage = can('commissions.manage');
  const current = manage ? tab : 'extrato';

  return (
    <>
      <PageHeader
        title="Comissões"
        description={can('commissions.read_all') || manage ? 'Acompanhe e pague as comissões da equipe.' : 'Acompanhe suas comissões.'}
      />
      <Tabs
        value={current}
        onValueChange={(v) => {
          void setShared({ page: null, q: null });
          void setTab(v as (typeof TABS)[number]);
        }}
      >
        {manage && (
          <TabsList className="mb-4">
            <TabsTrigger value="extrato">Extrato</TabsTrigger>
            <TabsTrigger value="regras">Regras</TabsTrigger>
          </TabsList>
        )}
        <TabsContent value="extrato">
          <StatementTab />
        </TabsContent>
        {manage && (
          <TabsContent value="regras">
            <RulesTab />
          </TabsContent>
        )}
      </Tabs>
    </>
  );
}

export function CommissionsPage() {
  return (
    <RequirePermission anyOf={['commissions.read', 'commissions.read_all', 'commissions.manage']}>
      <CommissionsContent />
    </RequirePermission>
  );
}
